import React, { useContext, useState } from "react";
import { UserContext } from "../../providers/UserProvider";
import { firestore } from "../../firebase";
import NavBar from "../../components/NavBar";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import {
  groupedOptions,
  locationOptions,
  groupBadgeStyles,
  groupStyles,
} from "../data";
import Select from "react-select";
import { Button } from "react-bootstrap";

import "./style.css";

const PostLead = () => {
  const user = useContext(UserContext);
  const [userData, setUserData] = useState("");
  const [newLeadTitle, setNewLeadTitle] = useState("");
  const [newLeadExperience, setNewLeadExperience] = useState("");
  const [newLeadLocation, setNewLeadLocation] = useState("");
  const [newLeadDescription, setNewLeadDescription] = useState("");
  const [toggleLeadPostMsg,setToggleLeadPostMsg] = useState(false)
  const [toggleEmptyInputMsg,setToggleEmptyInputMsg] = useState(false)

  React.useEffect(() => {
    firestore.collection("usersData").doc(user.uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let data = doc.data();
          setUserData(data);
        } else {
          // doc.data() will be undefined in this case
          setUserData(null);
          console.log("No such document!");
        }
      })
      .catch(function (error) {
        setUserData(null);
        console.log("Error getting document:", error);
      });
  }, []);
  if (!userData) return <div>Loading Data</div>;
  const sections = [
    { title: "פרופיל", url: "/Profile"},
    { title: "אח בוגר", url: "#" },
    { title: "פורום מקצועי", url: "#" },
    { title: "הפניות תיקים", url: "/SearchLead" },
  ];

  const formatGroupLabel = (data) => (
    <div style={groupStyles}>
      <span>{data.label}</span>
      <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
  );

  const onChangeHandlerExp = (selectedOption) => {
    setNewLeadExperience(selectedOption.value);
  };
  const onChangeHandlerLocation = (selectedOption) => {
    setNewLeadLocation(selectedOption.value);
  };
  const onChangeHandler = (event) => {
    const { name, value } = event.currentTarget;
    if (name === "addLeadDescription") {
      setNewLeadDescription(value);
    } else if (name === "leadTitle") {
      setNewLeadTitle(value);
    } 
  };

  const handleSubmit = async () => {
    let userId = user.uid
    var leadDate = new Date();
    var dd = String(leadDate.getDate()).padStart(2, '0');
    var mm = String(leadDate.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = leadDate.getFullYear();
    leadDate = dd + '/' + mm + '/' + yyyy;

    setToggleEmptyInputMsg(false)
    if(!newLeadExperience || !newLeadLocation || !newLeadDescription){
      setToggleEmptyInputMsg(true)
      return;
    }
    try {
      await firestore.collection("leadsData").doc().set(
        {
          userId,
          userFullName: userData.userFullName,
          leadTitle: newLeadTitle,
          leadExp: newLeadExperience,
          leadLocation: newLeadLocation,
          leadDescription: newLeadDescription,
          leadDate
        }
      );
      setToggleLeadPostMsg(true)
    } catch (error) {
      console.error("Error creating user document", error);
    }
  };

  return (
    <div>
      <CssBaseline />
      <Container maxWidth="lg">
        <NavBar sections={sections} />
      </Container>
      <hr />

      <div className="addlead-page-wrapper">
        <div className="addlead-page-header">
          <div className="addlead-page-personal">
            <span className="addlead-page-data" style={{ fontWeight: "700" }}>
              אנא מלאו את פרטי ההפניה שלכם
            </span>
          </div>
        </div>
        <hr />

        <div className="add-lead-labelinput-wrapper">
          <label className="addlead-page-label">
            כותרת ההפניה:
          </label>
          <input
            className="profile-update-input"
            type="text"
            name="leadTitle"
            onChange={event => onChangeHandler(event)}
          />
        </div>
        <hr />

        <div className="add-lead-labelinput-wrapper">
          <label className="addlead-page-label">
            התמחות
          </label>
          <Select
            options={groupedOptions}
            formatGroupLabel={formatGroupLabel}
            placeholder="בחר"
            onChange={onChangeHandlerExp}
          />
        </div>
        <hr />

        <div className="add-lead-labelinput-wrapper">
          <label className="addlead-page-label">
            אזור ההפניה
          </label>
          <Select
            options={locationOptions}
            placeholder="בחר"
            onChange={onChangeHandlerLocation}
          />
        </div>
        <hr />

        <label className="addlead-page-label">
          אנא פרט בקצרה אודות ההפניה
        </label>
        <div className="add-lead-labelinput-wrapper">
          <textarea
            name="addLeadDescription"
            style={{ width: "400px", height: "135px" }}
            className="profile-update-input"
            onChange={(event) => onChangeHandler(event)}
          ></textarea>
        </div>

        <Button className='newLeadButton' onClick={handleSubmit} variant="success">
        פרסם הפניה
      </Button>{" "}
      <p className='addlead-page-label'>{toggleLeadPostMsg ? "תודה לך! ההפניה שלך פורסמה בהצלחה.": ""}</p>
      <p className='addlead-page-label' style={{color: "red"}}>{toggleEmptyInputMsg ? "אנא מלא את כל הפרטים.": ""}</p>
      
      </div>
    </div>
  );
};

export default PostLead;
